import { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { capturePublicApi } from '../api/captureApi';
import styles from './ReviewCapturePage.module.css';

export function ReviewStartPage() {
  // Review slug on current links; a raw location id on QR codes printed before
  // slugs existed. The server resolves either.
  const { locationRef } = useParams<{ locationRef: string }>();
  const navigate = useNavigate();
  // ?test=1 mints a staff test session, excluded from all analytics — reached
  // from the dashboard's "Test the patient flow" link, never from printed QRs.
  const [searchParams] = useSearchParams();
  const isTest = searchParams.get('test') === '1';
  // ?src= tags where the printed code was placed (e.g. business_card).
  const source = searchParams.get('src') ?? undefined;
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!locationRef) return;
    capturePublicApi
      .start(locationRef, { test: isTest, source })
      .then((res) => {
        const shortCode = res.data?.shortCode;
        if (shortCode) {
          navigate(`/r/${shortCode}`, { replace: true });
        } else {
          setError(true);
        }
      })
      .catch(() => setError(true));
  }, [locationRef, isTest, source, navigate]);

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.center}>
          {error ? (
            <p className={styles.errorMsg}>
              This link is invalid or the practice could not be found.
            </p>
          ) : (
            <div className={styles.spinner} aria-label="Loading…" />
          )}
        </div>
      </div>
    </div>
  );
}
